import { h } from 'preact';

import { LazyOverviewFormFactorCard } from '../../components/overviewFormFactorCard/lazyOverviewFormFactorCard.jsx';

export default function LazyPropertyOverview(_props) {
  return (
    <>
      <LazyOverviewFormFactorCard />
      <LazyOverviewFormFactorCard sx={{ mt: 4 }} />
    </>
  );
}
